/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workspace_Default_ReverseInputs */

const en_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default Reverse`)
};

const fr_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par défaut inversé`)
};

const de_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardmäßig umgekehrt`)
};

const it_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversione predefinita`)
};

const ru_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратный по умолчанию`)
};

const es_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversión predeterminada`)
};

const zh_cn2_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认反向`)
};

const ja_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デフォルトリバース`)
};

const hi_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिफ़ॉल्ट रिवर्स`)
};

const pt_pt2_workspace_default_reverse = /** @type {(inputs: Workspace_Default_ReverseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverso padrão`)
};

/**
* | output |
* | --- |
* | "Default Reverse" |
*
* @param {Workspace_Default_ReverseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspace_default_reverse = /** @type {((inputs?: Workspace_Default_ReverseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_Default_ReverseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_workspace_default_reverse(inputs)
	if (locale === "de") return de_workspace_default_reverse(inputs)
	if (locale === "it") return it_workspace_default_reverse(inputs)
	if (locale === "ru") return ru_workspace_default_reverse(inputs)
	if (locale === "es") return es_workspace_default_reverse(inputs)
	if (locale === "zh-CN") return zh_cn2_workspace_default_reverse(inputs)
	if (locale === "ja") return ja_workspace_default_reverse(inputs)
	if (locale === "hi") return hi_workspace_default_reverse(inputs)
	if (locale === "pt-PT") return pt_pt2_workspace_default_reverse(inputs)
	return en_workspace_default_reverse(inputs)
});